export default "__VITE_ASSET__CSFr9D8O__"